module.exports = __webpack_public_path__ + "img/book_plan.6a7053ea.svg";